var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "double-button btn btn__double-button" }, [
    _c(
      "div",
      { staticClass: "double-button--left double-button--pane" },
      [_vm._t("left")],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "double-button--right double-button--pane" }, [
      _c("div", { staticClass: "double-button--content" }, [_vm._t("right")], 2)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a0ceffce", { render: render, staticRenderFns: staticRenderFns })
  }
}